//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Features.js";
import "../Features/Features.FeatureBuilder.js";
import "../GeometricUtilities/GeometricUtilities.CurveShapingBuilder.js";
import "../Features/Features.FaceRecognitionBuilder.js";
import "../no/SelectPointList.js";
import "../GeometricUtilities/GeometricUtilities.Continuity.js";
import "../no/GeometricUtilities.js";
import "../no/SelectObjectList.js";
let d=[[[0,"BSurfaceExtractionOption",1,0],[0,"CanApplyToAll",1,0],[0,"CanCreateNewBody",1,0],[0,"CanKeepParameterization",1,0],[1,"CurveShaper",0,"GeometricUtilities.CurveShapingBuilder",0],[0,"ExtractTolerance",1,0],[1,"FaceToDeform",0,"Features.FaceRecognitionBuilder",0],[0,"InsertionMethod",1,0],[0,"Number",1,0],[0,"ParameterDirection",1,0],[1,"SpecifyPoints",0,"SelectPointList",0],[0,"TransitionType",1,0],[1,"UMaxContinuity",0,"GeometricUtilities.Continuity",0],[1,"UMinContinuity",0,"GeometricUtilities.Continuity",0],[1,"VMaxContinuity",0,"GeometricUtilities.Continuity",0],[1,"VMinContinuity",0,"GeometricUtilities.Continuity",0]],[[["curve"],"DeleteCurve",{},1,0],[["face"],"RemoveFeatureParameters",{},1,0]],[]];
SPLM.Features.IFormBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Features.IFormBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Features.IFormBuilder.ParameterDirectionOptions = Object.freeze({
    "IsoU" : "IsoU", "IsoV" : "IsoV"});

SPLM.Features.IFormBuilder.InsertionMethodOptions = Object.freeze({
    "Uniform" : "Uniform", "ThroughPoints" : "ThroughPoints", "BetweenPoints" : "BetweenPoints"});

SPLM.Features.IFormBuilder.TransitionTypes = Object.freeze({
    "Local" : "Local", "Global" : "Global"});

SPLM.Features.IFormBuilder.GlobalTransitionTypes = Object.freeze({
    "Blend" : "Blend", "Bell" : "Bell"});

SPLM.Features.IFormBuilder.BSurfaceExtractionOptions = Object.freeze({
    "Original" : "Original", "MinimumBounded" : "MinimumBounded", "FittedToBoundary" : "FittedToBoundary"});

export default SPLM;